export const SPECTRUM_WATERFALL_LABEL_AREA_PX = 56;
export const SPECTRUM_WATERFALL_AXIS_HEIGHT_PX = 36;
export const SPECTRUM_WATERFALL_ALLOCATION_BAND_HEIGHT_PX = 30;

export interface SpectrumWaterfallViewportRange {
    endMHz: number;
    spanMHz: number;
    startMHz: number;
}

export function getSweepEffectiveLeftPad(leftPadPx: number): number {
    return leftPadPx + SPECTRUM_WATERFALL_LABEL_AREA_PX;
}

export function getSweepContentWidth(params: {
    leftPadPx: number;
    pxPerMHz: number;
    rightPadPx: number;
    totalMHz: number;
}): number {
    const { leftPadPx, pxPerMHz, rightPadPx, totalMHz } = params;

    return Math.max(1024, Math.floor(pxPerMHz * totalMHz) + getSweepEffectiveLeftPad(leftPadPx) + rightPadPx);
}

export function getSweepViewportRange(params: {
    leftPadPx: number;
    pxPerMHz: number;
    scrollLeft: number;
    totalMHz: number;
    viewportWidth: number;
}): SpectrumWaterfallViewportRange {
    const { leftPadPx, pxPerMHz, scrollLeft, totalMHz, viewportWidth } = params;
    const effectiveLeftPad = getSweepEffectiveLeftPad(leftPadPx);
    const viewRight = scrollLeft + Math.max(0, viewportWidth - 1);
    const startMHz = Math.max(0, (scrollLeft - effectiveLeftPad) / Math.max(1e-6, pxPerMHz));
    const endMHz = Math.min(totalMHz, (viewRight - effectiveLeftPad) / Math.max(1e-6, pxPerMHz));

    return {
        endMHz,
        spanMHz: Math.max(0, endMHz - startMHz),
        startMHz,
    };
}
